import React from 'react';

const Membership = () => (
  <div className="flex flex-col items-center justify-center h-full text-center border-4 border-dashed border-gray-200 rounded-3xl p-20">
    <h1 className="text-3xl font-bold text-gray-300 uppercase tracking-widest">Digital Passes</h1>
    <p className="mt-4 text-gray-400 italic">UIAA Membership to Apple Wallet and Google Wallet <br /> Work in Progress</p>
  </div>
);

export default Membership;